import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { reactPlugin } from '@datadog/browser-rum-react';
import { ENV } from '@constants/env';
import constants from '@constants/constants.json';

const DATADOG_CLIENT_TOKEN = 'pub23c1dfa91ccc5f652b1c031ed1239233';
const DATADOG_SITE = 'us3.datadoghq.com';
const DATADOG_SERVICE = 'tendril-v3';

export const initDatadog = (): void => {
  // Datadog must never run locally.
  if (ENV === 'local') {
    return;
  }

  datadogRum.init({
    applicationId: 'bfc0a78d-c85b-4d5f-ac9f-6b8b714fd8ff',
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: ENV,
    version: constants.buildVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    plugins: [reactPlugin({ router: false })],
  });

  // service/env/version must match the RUM init exactly so logs are correlated
  // to RUM sessions and matched against the uploaded sourcemaps.
  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: ENV,
    version: constants.buildVersion,
    // RUM and globalErrorHandler already capture errors; forwarding them here
    // too would double-count every error.
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
  });
};
